import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionAuthFetchCurrentPayload,
	IActionAuthFetchCurrentPayloadDone,
	IActionAuthFetchCurrentPayloadError,
} from './types';

export const authFetchCurrent = actionCreatorAsync<
	IActionAuthFetchCurrentPayload,
	IActionAuthFetchCurrentPayloadDone,
	IActionAuthFetchCurrentPayloadError
>(
	'authFetchCurrent',
	async () => {
		const { data } = await Api.auth.current();

		return data;
	},
);
